<script setup lang="ts">
import { PhArrowDown } from '@phosphor-icons/vue'
import { ref } from 'vue'

defineProps<{ imageUrl: string; webUrl: string }>()
const offset = ref({ x: 0, y: 0 })
function move(event: PointerEvent) {
  if (
    event.pointerType !== 'mouse' ||
    window.matchMedia('(prefers-reduced-motion: reduce), (max-width: 760px)').matches
  )
    return
  const rect =
    event.currentTarget instanceof HTMLElement ? event.currentTarget.getBoundingClientRect() : null
  if (rect)
    offset.value = {
      x: ((event.clientX - rect.left) / rect.width - 0.5) * 12,
      y: ((event.clientY - rect.top) / rect.height - 0.5) * 8,
    }
}
</script>

<template>
  <section
    id="top"
    class="hero"
    :style="{ '--pointer-x': `${offset.x}px`, '--pointer-y': `${offset.y}px` }"
    @pointermove="move"
    @pointerleave="offset = { x: 0, y: 0 }"
  >
    <img
      v-if="imageUrl"
      class="hero-image"
      :src="imageUrl"
      alt="棱镜分光与实验室玻璃仪器"
      fetchpriority="high"
      decoding="async"
    />
    <div v-else class="hero-image image-placeholder hero-placeholder">首页首屏图</div>
    <div class="hero-wash" aria-hidden="true"></div>
    <div class="hero-spectrum" aria-hidden="true"><i></i><i></i><i></i></div>
    <div class="hero-particles" aria-hidden="true">
      <i
        v-for="n in 12"
        :key="n"
        :style="{ '--n': n, left: `${45 + ((n * 13) % 52)}%`, top: `${18 + ((n * 19) % 65)}%` }"
      ></i>
    </div>
    <div class="container hero-content">
      <h1>把课本里的科学，<br />变成可以亲手探索的实验</h1>
      <div class="hero-actions">
        <a class="button" :href="webUrl">开始实验</a>
      </div>
    </div>
    <a class="scroll-cue" href="#product" aria-label="继续了解产品">
      <PhArrowDown :size="20" />
    </a>
  </section>
</template>
